export default __webpack_public_path__ + "static/medgas_outlet_b.f6adf72d869d08e7a5cecb27ce4f376d.svg";